import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-fade-in',
    template: ' <div @fade><ng-content></ng-content></div> ',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('fade', [state('void', style({ opacity: 0 })), transition(':enter', [animate('400ms ease-in-out', style({ opacity: 1 }))])]),
    ],
})
export class FadeInComponent {}
